import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'liveScore'
})
export class LiveScoresPipe implements PipeTransform {

  transform(livescores: any[], ...args: unknown[]): any[] {
      let inprogress:any[] = [];
      let scheduled:any[] = [];
      let delayed:any[] = [];
      let completed:any[] = [];
      let final:any[] = [];
      let canceled:any[] = [];
      livescores = livescores.filter(match =>{
        let data = {
          label_title:'',
          label_away:'',
          score_away:'',
          label_home:'',
          score_home:'',
        };
       if(match.details.league?.toLowerCase() === args[0]){
          switch (match.status) {
            case 'in progress':
                if(match["details"]["league"] != "MLB"){
                  data.label_title = `${this.ordinal(match["scoreboard"]["currentPeriod"])} ${match["scoreboard"]["periodTimeRemaining"]}`
                  data.label_away = match["teams"]["away"]["abbreviation"];
                  data.score_away = match["scoreboard"]["score"]["away"];
                  data.label_home = match["teams"]["home"]["abbreviation"];
                  data.score_home = match["scoreboard"]["score"]["home"];
                }else if(match["details"]["league"] == "MLB"){
                  data.label_title = this.ordinal(match["scoreboard"]["currentPeriod"]);
                  data.label_away = match["teams"]["away"]["abbreviation"];
                  data.score_away = match["scoreboard"]["score"]["away"];
                  data.label_home = match["teams"]["home"]["abbreviation"];
                  data.score_home = match["scoreboard"]["score"]["home"];
                }
                inprogress.push(data);
              break;
            case 'scheduled':
                data.label_title = formatDate(match["schedule"]["date"],'MM/d h:mma','en_US');
                data.label_away = match["teams"]["away"]["abbreviation"];
                data.label_home = match["teams"]["home"]["abbreviation"];
                data.score_home = "";
                data.score_away = "";
                scheduled.push(data);
              break;
            case 'delayed':
                data.label_title = "Delayed";
                data.label_away = match["teams"]["away"]["abbreviation"];
                data.label_home = match["teams"]["home"]["abbreviation"];
                data.score_home = "";
                data.score_away = "";
                delayed.push(data);
              break;
            case 'completed':
                data.label_title = "Completed"
                data.label_away = match["teams"]["away"]["abbreviation"];
                data.label_home = match["teams"]["home"]["abbreviation"];
                data.score_home = match["scoreboard"]["score"]["home"];
                data.score_away = match["scoreboard"]["score"]["away"];
                completed.push(data);
              break;
            case 'final':
                data.label_title = "Final"
                data.label_away = match["teams"]["away"]["abbreviation"];
                data.label_home = match["teams"]["home"]["abbreviation"];
                data.score_home = match["scoreboard"]["score"]["home"];
                data.score_away = match["scoreboard"]["score"]["away"];
                final.push(data);
              break;
            case 'canceled':
                data.label_title = "Cancelled";
                data.label_away = match["teams"]["away"]["abbreviation"];
                data.label_home = match["teams"]["home"]["abbreviation"];
                data.score_home = "";
                data.score_away = "";
                canceled.push(data);
              break;
            default:
              break;
          }
          return true;
       }
       return false;
    })
    return [...inprogress,...scheduled,...delayed,...completed,...final,...canceled];
  }

  ordinal(int:any) {
    const ones = +int % 10, tens = +int % 100 - ones;
    return int + ["th","st","nd","rd"][ tens === 10 || ones > 3 ? 0 : ones ];
  }

}
